<template>
    <Dialog modal header="Valoraciones en el Web Service de MUTUA" :style="{width: '80em'}">
        <div style="overflow-y: auto;">
            <div style="display: grid; gap: 10px">
                <table class="table">
                    <thead>
                        <tr>
                            <th></th>
                            <th scope="col">Servicio</th>
                            <th scope="col">Tipo</th>
                            <th scope="col">Gremio</th>
                            <th scope="col">Estado</th>
                            <th scope="col">Situación</th>
                            <th scope="col">Perceptor</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="valoracion in valoraciones_mutua" :key="valoracion">
                            <td></td>
                            <td>{{ valoracion.id_comunicacion_mensaje }}</td>
                            <td>{{ valoracion.tipo_servicio }}</td>
                            <td>{{ valoracion.gremio }}</td>
                            <td>{{ valoracion.estado_servicio }}</td>
                            <td>{{ valoracion.situacion_servicio }}</td>
                            <td>{{ valoracion.perceptor }}</td>
                            <td>
                                <div style="display: flex; justify-content: space-between;">
                                    <Button class="btn btn-sm" @click="accionValoracion(valoracion.id_comunicacion_mensaje, 'valoraciones')" v-if="valoracion.consultar_trabajo == 1" title="Consultar trabajo"><i class="fas fa-wrench"></i></Button>
                                    <Button class="btn btn-sm" @click="accionValoracion(valoracion.id_comunicacion_mensaje, 'confirmar')" v-if="valoracion.consultar_valoracion == 1" title="Confirmar valoración"><i class="fas fa-save"></i></Button>
                                    <Button class="btn btn-sm" @click="accionValoracion(valoracion.id_comunicacion_mensaje, 'facturas')" v-if="valoracion.consultar_facturas == 1" title="Consultar facturas"><i class="fas fa-file-invoice"></i></Button>
                                    <Button class="btn btn-sm" @click="accionValoracion(valoracion.id_comunicacion_mensaje, 'liquidaciones')" v-if="valoracion.consultar_liquidacion == 1" title="Consultar liquidación"><i class="fas fa-calculator"></i></Button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="mostrar == 'valoraciones'">
                    <h3>Trabajos del servicio</h3>
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col">Código</th>
                                <th scope="col">Unidades</th>
                                <th scope="col">Importe Base</th>
                                <th scope="col">Impuesto</th>
                                <th scope="col">Importe total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="articulo in datos_extra_mutua" :key="articulo">
                                <td>{{ articulo.nombreGrupoArticulo }}-{{ articulo.nombreArticulo }}</td>
                                <td>{{ articulo.cantidadUnidad }}</td>
                                <td>{{ articulo.total-articulo.totalImpuesto }}</td>
                                <td>{{ articulo.impuesto.descripcion }}({{ articulo.impuesto.porcentajeDesc }}% articulo.totalImpuesto)</td>
                                <td>{{ articulo.total }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="mostrar == 'facturas'">
                    <h3>Facturas del servicio</h3>
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col">Número factura</th>
                                <th scope="col">Fecha Mod.</th>
                                <th scope="col">Estado Base</th>
                                <th scope="col">Perceptor</th>
                                <th scope="col">Importe total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="factura in datos_extra_mutua" :key="factura">
                                <td>{{ factura.numFacturaExterna }}</td>
                                <td>{{ factura.cantidadUnidad }}</td>
                                <td>{{ factura.estadoFactura }}</td>
                                <td>{{ factura.perceptor }}</td>
                                <td>{{ factura.importe }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="mostrar == 'liquidaciones'">
                    <h3>Liquidación del servicio</h3>
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col">Expediente</th>
                                <th scope="col">Concepto</th>
                                <th scope="col">Fecha</th>
                                <th scope="col">Estado</th>
                                <th scope="col">Base</th>
                                <th scope="col">Total IVA</th>
                                <th scope="col">Importe Total</th>
                                <th scope="col">Número factura</th>
                                <th scope="col">Cliente y NIF</th>
                                <th scope="col">Conformidad</th>
                                <th scope="col">Orden de Trabajo</th>
                                <th scope="col">Reparación</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="liquidacion in datos_extra_mutua" :key="liquidacion">
                                <td>{{ liquidacion.numExpediente }}</td>
                                <td>{{ liquidacion.conceptoLiquidacion }}</td>
                                <td>{{ liquidacion.fechaAltaLiquidacion }}</td>
                                <td>{{ liquidacion.estadoLiquidacion }}</td>
                                <td>{{ liquidacion.totalSinImpuestos }}</td>
                                <td>{{ liquidacion.totalIVA }}</td>
                                <td>{{ liquidacion.totalConImpuestos }}</td>
                                <td>{{ liquidacion.numFacturaExterna }}</td>
                                <td>{{ liquidacion.titularFactura }} {{ liquidacion.nifTitularFactura }}</td>
                                <td>{{ liquidacion.flagFirmaConformidad }}</td>
                                <td>{{ liquidacion.flagOrdenTrabajo }}</td>
                                <td>{{ liquidacion.reparacion }}</td>
                            </tr>
                            <div v-if="liquidacion && liquidacion.listaLiquidacionDependientes && Array.isArray(liquidacion.listaLiquidacionDependientes)">
                                <tr>
                                    <td colspan="10">Servicios Dependientes, perceptor {{ liquidacion.perceptor }}</td>
                                    <td>Estado</td>
                                    <td>Importe Total</td>
                                </tr>
                                <tr v-for="servicio_dependiente in liquidacion.listaLiquidacionDependientes" :key="servicio_dependiente">
                                    <td colspan="10">{{ servicio_dependiente.idServicio }}</td>
                                    <td>{{ servicio_dependiente.estadoLiquidacionLiteral }}</td>
                                    <td>{{ servicio_dependiente.importeTotal }}</td>
                                </tr>
                                <tr>
                                    <td colspan="8">TOTAL</td>
                                    <td colspan="4">liquidacion.total</td>
                                </tr>
                            </div>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </Dialog>    
</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi';
export default {
    props: ['id', 'oficios'],
    components: {
    },
    data() {
        return {
            // totales_dependientes:[],
            valoraciones_mutua:[],
            datos_extra_mutua:null,
            mostrar:null,
        }
    },
    methods: {
        async accionValoracion(id_mutua, tipo){
            const api = new PwgsApi();
            if(tipo == 'confirmar'){
                //
            }else{
                const resp = await api.post('servicios/'+this.id+'/consulta-datos-mutua',{id_servicio_mutua:id_mutua, tipo:tipo});
                this.datos_extra_mutua = resp;
                this.mostrar = tipo;
            }
        },
        async cargarTrabajos() {
            const api = new PwgsApi();
            const response = await api.get('servicios/'+this.id+'/mensajes-asignacion-mutua');
            this.valoraciones_mutua = response;
        },
    }
}
</script>